module.exports = __webpack_public_path__ + "static/media/web logos_SEGA.c64ee85a.jpg";